import script from "./EntitySelectorButton.vue?vue&type=script&setup=true&lang=js"
export * from "./EntitySelectorButton.vue?vue&type=script&setup=true&lang=js"

import "./EntitySelectorButton.vue?vue&type=style&index=0&id=b7dbcbb0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7dbcbb0"]])

export default __exports__